// extracted by mini-css-extract-plugin
export var wrap = "Tabs-module--wrap--1FarH";
export var active = "Tabs-module--active--1XvxZ";
export var tabKey = "Tabs-module--tabKey--1x4GI";
export var tab = "Tabs-module--tab--AbHS3";
export var tabKeyActive = "Tabs-module--tabKeyActive--4s-5b";
export var tabActive = "Tabs-module--tabActive--1c31b";